import { render, staticRenderFns } from "./saml-authentication-error.component.vue?vue&type=template&id=7629294a&scoped=true&"
import script from "./saml-authentication-error.component.ts?vue&type=script&lang=js&"
export * from "./saml-authentication-error.component.ts?vue&type=script&lang=js&"
import style0 from "./saml-authentication-error.component.css?vue&type=style&index=0&id=7629294a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7629294a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
